"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvedEnvironmentVariables = void 0;
const fallbackEnvs_1 = require("./fallbackEnvs");
const env = process.env;
const default_region = env.AWS_DEFAULT_REGION ?? process.env.REACT_APP_AWS_DEFAULT_REGION ?? fallbackEnvs_1.fallBackEnvs.AWS_DEFAULT_REGION;
const region = default_region;
const accountId = env.accountId ?? process.env.REACT_APP_AWS_ACCOUNT_ID ?? fallbackEnvs_1.fallBackEnvs.accountId;
const projectCode = env.projectCode ?? process.env.REACT_APP_PROJECT_CODE ?? fallbackEnvs_1.fallBackEnvs.projectCode;
const appName = env.projectName ?? process.env.REACT_APP_PROJECT_NAME ?? fallbackEnvs_1.fallBackEnvs.projectName;
const stage = env.EnvironmentParameter ?? process.env.REACT_APP_DEPLOYMENT_STAGE ?? fallbackEnvs_1.fallBackEnvs.stage;
const undefinedEnvironmentVariables = Object.entries({ default_region, region, accountId, projectCode, appName, stage }).reduce((arr, [key, value]) => {
    if (!(typeof value === 'string'))
        arr.push(key);
    return arr;
}, []);
if (undefinedEnvironmentVariables.length > 0) {
    throw new Error(`The following environment variables are not set ${undefinedEnvironmentVariables.join(', ')}`);
}
/**
 * RSE: changed (2024 01) to not use destructuring for `REACT_APP_...` variables, as React Native does not allow access — except directly via `process.env`
 */
const resolvedEnvironmentVariables = {
    default_region,
    region,
    accountId,
    projectCode,
    appName,
    stage,
};
exports.resolvedEnvironmentVariables = resolvedEnvironmentVariables;
